// ============================================================
// Payroll module manifest — R3 retrofit (2026-04-24).
//
// Owns Malaysian payroll calculation (EPF / SOCSO / EIS / PCB) +
// payslip immutability lifecycle + the two payroll routes
// (My Payslips for everyone, Generate Payslip for HR/director).
//
// Depends on hr (employee resolution + sensitive-field redaction).
// Cloud Function `issuePayslip` lives in functions/payroll-malaysia.js;
// it is the SOURCE OF TRUTH for the legal payslip — client-side calc
// is preview-only.
// ============================================================

export default {
  id:          'payroll',
  name:        'Payroll',
  version:     '1.0.0',
  description: 'Malaysian payroll calc (EPF/SOCSO/EIS/PCB) + immutable payslip issuance.',

  load: () => import('./index.js'),

  routes: [
    {
      id:       'my-payslips',
      label:    'My Payslips',
      icon:     '💰',
      // Section 'account' = self-service group between People and Admin.
      // 2026-05-04 sidebar-leak fix — gate on `payroll.read.self`. Every
      // role (including staff) gets this — see industry packs. The page
      // itself filters payslips to only the signed-in user's own records.
      section:  'account',
      sidebarPosition: 10,
      visible:  (role, hasPerm) => hasPerm('payroll.read.self'),
      mount:    'mountMyPayslips',
      unmount:  'unmountMyPayslips'
    },
    {
      id:       'generate-payslip',
      label:    'Generate Payslip',
      icon:     '🧾',
      section:  'account',
      sidebarPosition: 40,
      // 2026-05-04 sidebar-leak fix — gate on `payroll.issue`. Granted to:
      // director ('*'), admin (__ALL_EXCEPT_TENANT_CONFIG__), hr (payroll.*).
      // Issuance is server-authoritative via the issuePayslip Cloud Function;
      // this is sidebar visibility only.
      visible:  (role, hasPerm) => hasPerm('payroll.issue'),
      mount:    'mountGeneratePayslip',
      unmount:  'unmountGeneratePayslip'
    }
  ],

  schemas: [
    'payslips'             // immutable issued payslips
  ],

  permissions: [
    'payroll.read.self',   // see own payslips
    'payroll.read.all',    // see everyone (HR + director)
    'payroll.issue',       // create a new payslip (HR + director)
    'payroll.delete'       // future delete-and-reissue flow (director only)
  ],

  dependencies: ['hr'],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  // Cloud Function `issuePayslip` enforces the actual write —
  // Rules ensure update:false / delete:false on the resulting doc.
  functions: ['issuePayslip'],

  dashboardWidgets: []   // No dashboard widgets — payroll runs are scheduled, not at-a-glance.
};
